// src/component/common/Loader.tsx
import { useLoader } from "../../context/LoaderContext";

export default function LoaderOverlay() {
  const { isLoading } = useLoader();
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="w-12 h-12 border-4 border-white border-t-blue-500 rounded-full animate-spin"></div>
    </div>
  );
}
